import { render, staticRenderFns } from "./ModalImportacao.vue?vue&type=template&id=45a44f77&"
import script from "./ModalImportacao.vue?vue&type=script&lang=js&"
export * from "./ModalImportacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports